import { resignationRequestProcessService } from '@/services/v2/resignation-request-process-service'
const tabs = {
  ResignationRequestList: () => import('@/views/management/Resignation/resignation-request/ResignationsList.vue'),
  NewResignationRequest: () => import ('@/views/management/Resignation/resignation-request'),
  ResignationRequestView: () => import ('@/views/management/Resignation/resignation-request/resignation-request-view'),
  ResignationRequestEvaluate: () => import('@/views/management/Resignation/resignation-request/resignation-request-evaluate')
}

const defaultResignationRequests = () => []

const state = {
  currentResignationRequestTab: tabs.ResignationRequestList,
  storageResignationRequests: [],
  filters: {
    client: null,
    keyword: '',
    status: null,
    page: 1,
    limit: 20
  },
  tabs
}

const mutations = {
  SET_TABS: (state, tab) => {
    state.currentResignationRequestTab = state.tabs[tab]
  },

  SET_FILTERS: (state, filters) => {
    state.filters = { ...state.filters, ...filters }
  },

  SET_RESIGNATION_REQUESTS: (state, resignationRequests) => {
    state.storageResignationRequests = resignationRequests
  },

  CLEAR_RESIGNATION_REQUESTS: (state) => {
    state.storageResignationRequests = defaultResignationRequests()
  }
}

const actions = {
  setCurrentResignationTab({ commit }, tab) {
    commit('SET_TABS', tab)
  },

  async fetchResignationRequests({ commit, state }, filters = {}) {
    const filledFilters = { ...state.filters, ...filters }
    commit('SET_FILTERS', filledFilters)
    const { client, keyword, status, page, limit } = filledFilters
    const { data } = await resignationRequestProcessService.getResignationRequestByKeyword(client, keyword, status, limit, page)
    commit('SET_RESIGNATION_REQUESTS', data.docs)
  },

  clearResignationRequest({ commit }) {
    commit('CLEAR_RESIGNATION_REQUESTS', defaultResignationRequests())
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
